// RingCentral's extension ID (what the server matches) is a long number; the extension number people dial is short.
// Both are digits, so the form can't refuse one: it warns when what was typed looks like the short one.
export const looksLikeExtensionNumber = (s: string) => /^\d{1,6}$/.test(s.trim());

export const EXTENSION_NUMBER_HINT = 'That looks like an extension number. Use the long numeric extension ID from the RingCentral admin portal.';
